var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(!_vm.noLabel)?[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.$t("people:ShoppingBasket.ShoppingBasketTab.Competition.label"))+":")]})]:_vm._e(),_vm._v("\n  "+_vm._s(_vm.competition.code)),(_vm.competition.name)?[_vm._v(" | ")]:_vm._e(),_vm._v(_vm._s(_vm.competition.name)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }